import React, { useRef } from 'react';
import Grid from '@mui/material/Grid';
import LearnMore from './components/LearnMore';
import PlanForLifes from './components/PlanForLifes';
import StartHere from './components/StartHere';
import LifetimeSSBenefitEstimator from './components/LifetimeSSBenefitEstimator';
import './styles.scss';

import Results from './components/Results';
import { useAppContext } from '../../context/appContext';

const Home = () => {
  const {
    store: {
      page,
    },
  } = useAppContext();
  const learnMoreRef = useRef(null);
  const calculateRef = useRef(null);

  return (
    page === 'home'
      ? (
        <Grid container className='home-page' justifyContent='center'>
          <Grid item xs={12}>
            <StartHere learnMoreRef={learnMoreRef} calculateRef={calculateRef} />
          </Grid>
          <Grid className='plan-for-life-wrapper' item xs={12} ref={learnMoreRef}>
            <PlanForLifes calculateRef={calculateRef} />
          </Grid>
          <Grid item xs={12}>
            <LearnMore />
          </Grid>
          <Grid className='estimator-wrapper' item xs={12} ref={calculateRef}>
            <LifetimeSSBenefitEstimator />
          </Grid>
        </Grid>
      )
      : <Results />
  );
};

export default Home;
